import axios from 'axios';
import { clearAdminToken, getAdminToken } from '../utils/adminAuth';

const adminPatientsApi = axios.create({
  baseURL: '/api/v1/admin/patients',
  withCredentials: true
});

adminPatientsApi.interceptors.request.use(
  (config) => {
    const token = getAdminToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

adminPatientsApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      clearAdminToken();
      if (typeof window !== 'undefined') {
        window.location.href = '/web/admin-login';
      }
    }
    return Promise.reject(error);
  }
);

export const listAdminPatients = async (params = {}) => {
  const response = await adminPatientsApi.get('', { params });
  return response.data;
};

export const createAdminPatient = async (payload) => {
  const response = await adminPatientsApi.post('', payload);
  return response.data;
};

export const patchAdminPatient = async (id, payload) => {
  const response = await adminPatientsApi.patch(`/${id}`, payload);
  return response.data;
};
